import { BASE_ROUTE, RouteParams } from "../../../constants";

export const BASE_GRID_ROUTE = `/${BASE_ROUTE}/grids`;

export const GridPages = {
  actions: {
    path: `/actions`,
    generateLink: (organisationId: number | string, projectId: number | string) =>
      `${BASE_GRID_ROUTE.replace(RouteParams.organisationId, organisationId + "")}/projects/${projectId}/actions`
  },
  projectStakeholders: {
    path: `/stakeholders`,
    generateLink: (organisationId: number | string, projectId: number | string) =>
      `${BASE_GRID_ROUTE.replace(RouteParams.organisationId, organisationId + "")}/projects/${projectId}/stakeholders`
  },
  impacts: {
    path: `/impacts`,
    generateLink: (organisationId: number | string, projectId: number | string) =>
      `${BASE_GRID_ROUTE.replace(RouteParams.organisationId, organisationId + "")}/projects/${projectId}/impacts`
  },
  impactGroups: {
    path: `/impact-groups`,
    generateLink: (organisationId: number | string, projectId: number | string) =>
      `${BASE_GRID_ROUTE.replace(RouteParams.organisationId, organisationId + "")}/projects/${projectId}/impact-groups`
  },
  audiences: {
    path: `/audiences`,
    generateLink: (organisationId: number | string, projectId: number | string) =>
      `${BASE_GRID_ROUTE.replace(RouteParams.organisationId, organisationId + "")}/projects/${projectId}/audiences`
  },
  readinessTracking: {
    path: `/readiness-tracking`,
    generateLink: (organisationId: number | string, projectId: number | string) =>
      `${BASE_GRID_ROUTE.replace(
        RouteParams.organisationId,
        organisationId + ""
      )}/projects/${projectId}/readiness-tracking`
  },
  processes: {
    path: `/processes`,
    generateLink: (organisationId: number | string, projectId: number | string) =>
      `${BASE_GRID_ROUTE.replace(RouteParams.organisationId, organisationId + "")}/projects/${projectId}/processes`
  },
  roleToPositionMapping: {
    path: `/role-to-position-mapping`,
    generateLink: (organisationId: number | string, projectId: number | string) =>
      `${BASE_GRID_ROUTE.replace(
        RouteParams.organisationId,
        organisationId + ""
      )}/projects/${projectId}/role-to-position-mapping`
  },
  courseGroups: {
    path: `/course-groups`,
    generateLink: (organisationId: number | string, projectId: number | string) =>
      `${BASE_GRID_ROUTE.replace(RouteParams.organisationId, organisationId + "")}/projects/${projectId}/course-groups`
  },
  trainingCourses: {
    path: `/courses`,
    generateLink: (organisationId: number | string, projectId: number | string) =>
      `${BASE_GRID_ROUTE.replace(RouteParams.organisationId, organisationId + "")}/projects/${projectId}/courses`
  },
  trainingModules: {
    path: `/modules`,
    generateLink: (organisationId: number | string, projectId: number | string) =>
      `${BASE_GRID_ROUTE.replace(RouteParams.organisationId, organisationId + "")}/projects/${projectId}/modules`
  },
  trainingComponents: {
    path: `/training-components`,
    generateLink: (organisationId: number | string, projectId: number | string) =>
      `${BASE_GRID_ROUTE.replace(
        RouteParams.organisationId,
        organisationId + ""
      )}/projects/${projectId}/training-components`
  }
};
